import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiUrl } from './api-url';

export interface BindQriAssignment {
  id: number;
  terminalId: string;
  idCaja: string;
  idQr: number;
  qrString: string;
  provider: string;
}

export interface AvailableQriTerminal {
  id: number;
  terminalId: string;
  clientId: number | null;
}

export interface BindQriFilters {
  idCaja: string;
  idQr: number | null;
  terminalId: string;
}

export interface BindQriPage {
  content: BindQriAssignment[];
  totalElements: number;
  totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class BindQriApi {
  private readonly baseUrl = apiUrl('/management/bind-qri');

  constructor(private readonly http: HttpClient) {}

  list(page: number, size: number, filters: BindQriFilters): Observable<BindQriPage> {
    let params = new HttpParams().set('page', page).set('size', size).set('sort', 'id,desc');
    if (filters.idCaja.trim()) params = params.set('idCaja', filters.idCaja.trim());
    if (filters.terminalId.trim()) params = params.set('terminalId', filters.terminalId.trim());
    if (filters.idQr !== null) params = params.set('idQr', filters.idQr);
    return this.http.get<BindQriPage>(this.baseUrl, { params });
  }

  availableTerminals(): Observable<AvailableQriTerminal[]> {
    return this.http.get<AvailableQriTerminal[]>(`${this.baseUrl}/available-terminals`);
  }

  assign(virtualTerminalId: number): Observable<Omit<BindQriAssignment, 'id' | 'terminalId'>> {
    return this.http.post<Omit<BindQriAssignment, 'id' | 'terminalId'>>(
      `${this.baseUrl}/virtual-terminal/${virtualTerminalId}`, null);
  }

  delete(assignmentId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${assignmentId}`);
  }
}
